export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.23-1001.53",
  commitId: "a3fd190ac7826905fb9c2b402ec1673b2daadd69",
  commitTime: "2026-07-23T10:01:53.000Z",
});
